<ng-container *ngrxLet="remoteDiagnosticsSnapshotsStore.showSnapshotsLoader$ | async as loader">
  <vi-loader
    *ngIf="loader"
    data-at-loader
    message="{{ '+REMOTE_DIAGNOSTICS_BACKUPS.LOADER.LOADING_BACKUPS_TEXT' | translate }}"
    [isLoading]="true"
  >
  </vi-loader>
  <div class="backup-list-container flex flex-col gap-[24px]" *ngIf="!loader">
    <app-month-datepicker
      class="datepicker"
      gtmCategory="vddBackups"
      gtm="onSelect"
      gtmAction="Select Month"
      [minDate]="(gatewayProperties$ | async)?.registeredAt"
      (dateChanged)="changeDate($event)"
    ></app-month-datepicker>
    <ng-container *ngIf="displayedBackups.length">
      <div
        class="snapshots-container flex flex-row flex-wrap gap-[12px] justify-start items-center lt-md:justify-center grid"
      >
        <app-backup-item
          class="full-width"
          *ngFor="let backup of displayedBackups"
          [backup]="backup"
        >
        </app-backup-item>
      </div>
      <button
        *ngIf="
          (remoteDiagnosticsSnapshotsStore.snapshotsFilteredLength$ | async) >
          SHOW_MORE_BACKUPS_THRESHOLD
        "
        gtm="onToggle"
        gtmAction="expand or collapse backups"
        gtmCategory="vddSnapshots"
        mat-button
        color="primary"
        (click)="toggleShowMoreBackups()"
      >
        <!-- +REMOTE_DIAGNOSTICS_SNAPSHOTS.BTN.RESET_FILTER -->
        <ng-template
          [ngIf]="remoteDiagnosticsSnapshotsStore.isShowingMoreSnapshots$ | async"
          [ngIfElse]="collapseIcon"
        >
          <span>{{ 'GENERAL.BUTTON.SHOW_LESS' | translate }}</span>
          <mat-icon>keyboard_arrow_up</mat-icon>
        </ng-template>
        <ng-template #collapseIcon>
          <span>{{ 'GENERAL.BUTTON.SHOW_MORE' | translate }}</span>
          <mat-icon #collapseIcon>keyboard_arrow_down</mat-icon>
        </ng-template>
      </button>
    </ng-container>
    <div *ngIf="displayedBackups.length === 0" class="backups-empty-list-text">
      {{ '+REMOTE_DIAGNOSTICS_BACKUPS.TEXT.EMPTY_FILTERED_BACKUP_LIST' | translate }}
    </div>
  </div>
</ng-container>
